<div class="dg-url-list text-end">
  <a
    href="{{ baseval }}/admin/project-config-details?projectId=8"
    target="_blank"
    class="urlTxt"
    ><span class="dg-fs-14">Environment : {{ environment }} </span></a
  >

  <button class="dg-hover-url me-3 env1">
    <mat-icon class="dg-fs-14">info</mat-icon>
  </button>

  <div
    class="card hide-url position-absolute top-50 start-50 translate-middle overflow-auto"
  >
    <div class="card-body p-2">
      <ul class="list-inline text-start">
        <li *ngFor="let url of urlval">
          <div *ngIf="url.label != 'branding'">
            <span class="badge dg-bg-primary text-white"
              >{{ url.label }} :
            </span>
            {{ url.value }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
